module.exports = __webpack_public_path__ + "static/logo-3bcfbbe36ef533979ea588e496036b50.svg";